
































































































import { Component, Vue, Watch, VModel, Emit } from 'vue-property-decorator'

import type { Captcha, CaptchaCheck } from '@/api'

import { ApiError } from '@/api'

import { captcha } from '@/store/modules/captcha'

@Component<CaptchaDialog>({})
class CaptchaDialog extends Vue {
  @VModel({ type: Boolean, default: false, validator: value => typeof value === 'boolean' }) isShowModal!: boolean

  @Emit()
  success(): CaptchaCheck {
    return { answers: [...this.captchaCheck.answers] }
  }

  captchaModule = captcha.context(this.$store)

  captcha: Captcha = null
  captchaCheck: CaptchaCheck = { answers: [] }
  captchaError: string | null = null

  @Watch('isShowModal', { immediate: true })
  async createCleanCaptcha(isCreate = true) {
    this.captcha = null
    this.cleanCaptchaError()
    this.cleanCaptchaCheckAnswers()

    if (isCreate) this.captcha = await this.captchaModule.actions.generateCapctha()
  }

  @Watch('captchaModule.getters.isGenerateCaptcha')
  cleanCaptchaCheckAnswers(value = true) {
    if (!value) this.captchaCheck.answers = []
  }

  @Watch('captchaCheck.answers')
  cleanCaptchaError() {
    this.captchaError = null
  }

  async validate() {
    try {
      await this.captchaModule.actions.validateCaptcha({ captcha: this.captchaCheck })
      this.success()
      this.isShowModal = false
    } catch (error) {
      await this.createCleanCaptcha(true)
      if (error instanceof ApiError) this.captchaError = error.body?.description
      if (!this.captchaError) this.captchaError = 'Неизвестная ошибка попробуйте еще раз'
    }
  }

  itemBoxShadowHovering: Partial<CSSStyleDeclaration>['boxShadow'] =
    'inset 0 0 0 3px var(--v-primary-lighten1) !important'
  itemBoxShadowSelected: Partial<CSSStyleDeclaration>['boxShadow'] =
    'inset 0 0 0 3px var(--v-primary-darken1) !important'
}

export default CaptchaDialog
